/* eslint-disable no-case-declarations */
/* eslint-disable react/jsx-no-constructed-context-values */
/*
 * Author M. Atoar Rahman
 * Title: Layer Chaining Context
 * Description: Layer Chaining Context
 * Date: 20/06/2022
 */

import { createContext, useContext, useReducer, useState } from 'react';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import ToastifyService from '../../../services/ToastifyService';
import UrlService from '../../../services/UrlService';

// Initial State
const initialState = {
    layerChain: [],
};

// Reducer Function
const reducer = (state, action) => {
    switch (action.type) {
        case 'LIST_DATA':
            return {
                ...state,
                layerChain: action.payload,
            };
        case 'ADD_REQ':
            return {
                ...state,
                layerChain: [...state.layerChain, action.payload],
            };
        case 'EDIT_REQ':
            const actionPayload = action.payload;
            const updateLayerChaining = state.layerChain.map((el) => {
                if (el.id === actionPayload.id) {
                    return actionPayload;
                }
                return el;
            });
            return {
                ...state,
                layerChain: updateLayerChaining,
            };

        default:
            return state;
    }
};

// Create Context
const ContextAPI = createContext(initialState);

export function useLayerChaining() {
    return useContext(ContextAPI);
}

// Provider Component
export function LayerChainingProvider({ children }) {
    const [state, dispatch] = useReducer(reducer, initialState);
    const [show, setShow] = useState(false);
    const [rowData, setRowData] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);

    // Dependency
    const axiosPrivate = useAxiosPrivate();

    // API Function: Fatch All Data
    const getAllData = async () => {
        try {
            const response = await axiosPrivate.get(UrlService.getAllLayerChainingUrl(), {
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            dispatch({
                type: 'LIST_DATA',
                payload: response?.data?.layer_chain,
            });
        } catch (err) {
            if (!err?.response) {
                console.log('Server Not Responding!');
            } else if (err.response?.status === 401) {
                console.log('Unauthorized!');
            } else {
                console.log('Data Not Found!');
            }
        }
    };

    // API Function: Add/Edit Data
    const addOrUodateData = async (data, id) => {
        try {
            await axiosPrivate.post(
                id ? UrlService.updateLayerChainingUrl(id) : UrlService.saveLayerChainingUrl(),
                JSON.stringify(data),
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            );
            if (id != null) {
                ToastifyService.updateNotify('Data Update Successfull');
            } else {
                ToastifyService.saveNotify('Data Create Successfull');
            }
            await getAllData();
            setIsSubmitted(true);
        } catch (err) {
            if (!err?.response) {
                console.log('Server Not Responding!');
            } else if (err.response?.status === 401) {
                console.log('Unauthorized!');
            } else if (id) {
                console.log('Data Update Failed!');
            } else {
                console.log('Data Insert Failed!');
            }
            setIsSubmitted(false);
        }
    };

    // Add Layer Chaining
    const addLayerChaining = (data) => {
        addOrUodateData(data);
        dispatch({
            type: 'ADD_REQ',
            payload: data,
        });
    };

    // Edit Layer Chaining
    const editLayerChaining = (data, id) => {
        addOrUodateData(data, id);
        dispatch({
            type: 'EDIT_REQ',
            payload: data,
        });
    };

    return (
        <ContextAPI.Provider
            value={{
                layerChain: state.layerChain,
                getAllData,
                addLayerChaining,
                editLayerChaining,
                show,
                setShow,
                rowData,
                setRowData,
                isSubmitted,
                setIsSubmitted,
            }}
        >
            {children}
        </ContextAPI.Provider>
    );
}

export default ContextAPI;
